import { GoogleAnalyticsService } from './shared/services/google-analytics/google-analytics.service';
import { TokenStorageService } from './core/security/token-storage-service';
import { Storage } from 'src/app/core/services/storage.service';
import { Subscription } from 'rxjs';
import { MenuService } from './services/menu/menu.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ApplicationRoutes } from './core/consts/routes';
import { CurrentUserService } from './core/services/current-user.service';
import { Title } from '@angular/platform-browser';
import { FlashMessageService } from './shared/services/flash-message.service';
import { CustomerService } from './services/customer/customer.service';
import { RedirctUrlService } from './shared/services/redirct-url.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { ConfigService } from './core/services/config.service';
import { HeaderService } from './shared/services/header/header.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { AnnouncementsService } from 'src/app/shared/services/announcements/announcements.service';
import { ModalService } from './shared/services/modal.service'
import { AnnouncementPopupComponent } from './components/announcement-popup/announcement-popup.component'
import { NavMenuComponent } from '@hubgroup/hubconnect-ui-commons';

@Component({
  selector: 'hg-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'User-app';
  routes = ApplicationRoutes;
  public currentUserService;

  @ViewChild('sideMenu', {static: false}) navMenuComponent: NavMenuComponent;

  constructor(
    private router: Router,
    private _currentUserService: CurrentUserService,
    private _route: ActivatedRoute,
    private _menuService: MenuService,
    private _titleService: Title,
    public flashMessageService: FlashMessageService,
    private _customerService: CustomerService,
    private _redirectUrlService: RedirctUrlService,
    private _gaSvc: GoogleAnalyticsService,
    private config: ConfigService,
    private tokenService: TokenStorageService,
    private HeaderSvc: HeaderService,
    private storageSvc: TokenStorageService,
    private _appNotificationService: AppNotificationService,
    private _announcementService: AnnouncementsService,
    private modal: ModalService,
    private storage: Storage
  ) {
    this.currentUserService = _currentUserService;
  }

  private menuServiceObs: Subscription;
  public organizationName: string;
  public userName: string;
  public roleType: string;

  public menuItems = [];
  public showNavBar: boolean = true;
  public isSupportUser: boolean = false;

  async ngOnInit() {
    if(window.location.href.indexOf('carriers/request-access') > 0 || window.location.href.indexOf('request-access') > 0) {
      this.showNavBar = false;
      return;
    }

    await this.HeaderSvc.setAdditionalMenuOptions();

    if (await this.storageSvc.isSupportUser()) {
      this.isSupportUser = true;

      const user = await this._currentUserService.getUser();
      this.userName = user.username;
      this.organizationName = user.organizationName;

      this._gaSvc.register('Login', `${user.username} support user logged in.`);
      return;
    }

    await this.currentUserService.setIsImpersonator();
    this._initMobileRouter();
    this._setUserSupportOptions();
    this._setCarrierSupportOptions();
    this._setDisplayName();
    this._setSwitchProfileOption();

    this._titleService.setTitle('Hub Group Connect');
    this.currentUserService.initalizeLogin();
    this.currentUserService.getUser().then(user => {
      this.organizationName = (this.currentUserService.user) ? this.currentUserService.user.organizationName : '';
      this.userName = (this.currentUserService.user) ? this.currentUserService.user.username : '';
      this.roleType = _.get(this.currentUserService.user, 'role.type', '');

      this.menuServiceObs = this._menuService.getMenuItems().subscribe((menuItems: any[]) => {
        this.menuItems = menuItems;
        if (this.currentUserService.isInternal) {
          this._customerService.getCustomerRequestsCount();
        }
        this._setSelectedMenuItem(this.router.url);
      }, err => {
        console.log("Error");
      });
    });
    this._customerService.requestCount$.subscribe((count: any) => {
      this._updateRequestCount(count);
    });

    this._setSelectedMenuObserver();
    if (await this._appNotificationService.getNotificationEnabledStatus()) {
      this._appNotificationService.loadNotifications('general', 0);

      // Check for notification popups
      const highPriorityNotification = await this._appNotificationService.getHighPriorityNotification('general')
      const announcmentId = _.get(highPriorityNotification[0], 'notificationContent.additionalData.announcementId', '')
      if (highPriorityNotification  && highPriorityNotification.length > 0 && announcmentId) {
        //Grab the assosciated announcement
        const announcement = await this._announcementService.getAnnouncement(announcmentId)
        //Display the popup
        this.modal.open(AnnouncementPopupComponent, {announcement: announcement, notification: highPriorityNotification[0]}, { panelClass: 'custom-panel-class', maxWidth: '100%' })
      }
    }
  }

  /**
   * Show 'User Support' option under profile dropdown if user is impersonator
   */
  private async _setUserSupportOptions() {
    const entitlements = await this._currentUserService.getEntitlements();
    const isImpersonator = await this.storageSvc.isImpersonator();
    if (isImpersonator || entitlements['HC_INTERNAL_CUST_SUPPORT']) {
      this.HeaderSvc.additionalMenuOptions.push({ path: '/user-support', title: "User Support" });
    }
  }

  /**
   * Show 'User Support' option under profile dropdown if user is impersonator
   */
  private async _setCarrierSupportOptions() {
    const entitlements = await this._currentUserService.getEntitlements();
    if (entitlements['HC_CR_SUPPORT_READ']) {
      this.HeaderSvc.additionalMenuOptions.push({ path: '/carrier-support', title: "Carrier Support" });
      this.HeaderSvc.additionalMenuOptions.push({ path: '/support-mode', title: 'Carrier Invoicing Support' });
    }
  }

  /**
   * Set impersonator's first as displayName if user is impernating
   * Otherwise take current logged in user
   */
  private async _setDisplayName() {
    try {
      const isImpersonator = await this.tokenService.isImpersonator();

      if (isImpersonator) {
        const impersonator = await this.tokenService.getImpersonator();
        this.HeaderSvc.displayName = JSON.parse(JSON.parse(impersonator)['user'])['firstname'];
      } else {
        this.HeaderSvc.displayName = (await this.currentUserService.getUser())['firstname'];
      }
    } catch(err) {
      this.HeaderSvc.displayName = 'USER';
    }
  }

  ngOnDestroy(): void {
    this.menuServiceObs.unsubscribe();
  }

  /**
   * Redirect to initial page in mobile app switch
   * check queryParam appRedirectUrl which is set from other app
   */
  private _initMobileRouter() {
    const isCordovaApp = document.URL.indexOf('http://') === -1
    if (isCordovaApp) {
      this._route.queryParams.subscribe(params => {
        if (params.appRedirectUrl) {
          this.router.navigateByUrl(params.appRedirectUrl);
        }
      });
    }
  };

  private _updateRequestCount(count: number = 0) {
    if (this.menuItems) {
      this.menuItems.forEach(item => {
        if (item.title && item.title === 'ADMIN' && item.subMenu) {
          item.subMenu.forEach(sm => {
            if (sm.title && sm.title === 'Requests') {
              sm['count'] = count;
            }
          });
        }
      });
    }
  }

  isActiveRouteOf(routeBase: string) {
    return this.router.url.substring(1, this.router.url.length) === routeBase;
  }

  /**
   * Redirect logig goes here
   *  */
  public async onRedirectHandler($event) {
    this._redirectUrlService.onRedirectHandler($event);
  }

  /**
 * Logout Logic goes here
 *  */
  public onLogoutHandler($event) {
    this._redirectUrlService.onLogoutHandler({ url: 'logout' });
  }

  /**
* Back logic goes here
*  */
  public onBackEventHandler() {
  }

  private _setSelectedMenuObserver() {
    this.router.events.subscribe((val) => {
      // set selected menu
      if (val instanceof NavigationEnd) {
        if (this.menuItems && this.menuItems.length) {
          this._setSelectedMenuItem(val.url);
        };
      }
    });
  }

  private _setSelectedMenuItem(url: string) {
    this.menuItems.forEach(menu => {
      if (menu.subMenu && menu.subMenu.length) {
        menu.subMenu.forEach(subMenu => {
          if (url.includes(subMenu.redirectUrl)) {
            subMenu['default'] = true;
          } else {
            subMenu['default'] = false;
          }
        });
        this.navMenuComponent.InitMenu();
      }
    });
  }

  /**
  * Show Switch Profile option in User Menu if user account has mulitiple profiles
  */
   private async _setSwitchProfileOption() {
    const isMultiProfileUser = await this.storageSvc.isMultiProfiler();
    if (isMultiProfileUser) {
      let switchProfile = 'Switch User Type';
      this.HeaderSvc.addAdditionalMenuOptions({ path: '/switch-profile', title: switchProfile });
    }
  }
}
